import { Text } from '@react-three/drei';
import { AxesHelper, Vector3 } from 'three';

interface LabeledAxesProps {
  size?: number;
}

export default function LabeledAxes({ size = 5 }: LabeledAxesProps) {
  return (
    <group>
      <primitive object={new AxesHelper(size)} />

      {/* X axis label (red) */}
      <Text position={new Vector3(size + 0.2, 0, 0)} fontSize={0.5} color="red" anchorX="left">
        X
      </Text>

      {/* Y axis label (green) */}
      <Text position={new Vector3(0, size + 0.2, 0)} fontSize={0.5} color="green" anchorY="bottom">
        Y
      </Text>

      {/* Z axis label (blue) */}
      <Text position={new Vector3(0, 0, size + 0.2)} fontSize={0.5} color="blue" anchorX="left">
        Z
      </Text>
    </group>
  );
}
